import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="autocomplete"
var _default = /*#__PURE__*/function (_Controller) {
  function _default() {
    _classCallCheck(this, _default);
    return _callSuper(this, _default, arguments);
  }
  _inherits(_default, _Controller);
  return _createClass(_default, [{
    key: "connect",
    value: function connect() {
      var _this = this;
      console.log('=== AUTOCOMPLETE CONNECT START ===');
      try {
        this.timeout = null;
        this.selectedIndex = -1;
        console.log('Autocomplete controller connected');

        //   // Close dropdown when clicking outside
        this.clickOutsideHandler = function (event) {
          if (!_this.element.contains(event.target)) {
            _this.hideResults();
          }
        };
        document.addEventListener('click', this.clickOutsideHandler);
        console.log('=== AUTOCOMPLETE CONNECT END ===');
      } catch (error) {
        console.error('=== AUTOCOMPLETE CONNECT ERROR ===', error);
        throw error;
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener('click', this.clickOutsideHandler);
      if (this.timeout) clearTimeout(this.timeout);
    }
  }, {
    key: "search",
    value: function search(event) {
      var _this2 = this;
      var query = event.target.value.trim();

      // Always sync the visible input to the hidden field for manual entry
      if (this.hasHiddenTarget) {
        this.hiddenTarget.value = query;
      }

      // Hide dropdown if search box is empty or query too short
      if (query.length === 0 || query.length < this.minCharsValue) {
        this.hideResults();
        return;
      }

      // Debounce the search
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        _this2.performSearch(query);
      }, 300);
    }
  }, {
    key: "performSearch",
    value: function () {
      var _performSearch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var url, response, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "".concat(this.urlValue, "?term=").concat(encodeURIComponent(query));
              _context.prev = 1;
              _context.next = 4;
              return fetch(url, {
                headers: {
                  Accept: 'application/json',
                  'X-Requested-With': 'XMLHttpRequest'
                }
              });
            case 4:
              response = _context.sent;
              if (response.ok) {
                _context.next = 7;
                break;
              }
              throw new Error('Network response was not ok');
            case 7:
              _context.next = 9;
              return response.json();
            case 9:
              data = _context.sent;
              this.showResults(data);
              _context.next = 17;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              console.error('Autocomplete error:', _context.t0);
              this.hideResults();
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 13]]);
      }));
      function performSearch(_x) {
        return _performSearch.apply(this, arguments);
      }
      return performSearch;
    }()
  }, {
    key: "showResults",
    value: function showResults(items) {
      var _this3 = this;
      if (items.length === 0) {
        this.hideResults();
        return;
      }
      console.log('Showing results:', items);
      this.resultsTarget.innerHTML = items.map(function (item, index) {
        var escaped = _this3.escapeHtml(item.label);
        return "\n        <li class=\"autocomplete-item ui-menu-item\" \n             data-index=\"".concat(index, "\"\n             data-id=\"").concat(_this3.escapeAttr(item.id), "\"\n             data-value=\"").concat(_this3.escapeAttr(item.value || item.id), "\"\n             data-label=\"").concat(_this3.escapeAttr(item.label), "\"\n             data-first-name=\"").concat(_this3.escapeAttr(item.first_name), "\"\n             data-last-name=\"").concat(_this3.escapeAttr(item.last_name), "\"\n             data-action=\"click->autocomplete#select mouseenter->autocomplete#highlight\">\n          ").concat(escaped, "\n        </li>\n      ");
      }).join('');
      this.resultsTarget.classList.remove('d-none');
      this.selectedIndex = -1;
    }
  }, {
    key: "hideResults",
    value: function hideResults() {
      if (this.hasResultsTarget) {
        this.resultsTarget.classList.add('d-none');
        this.selectedIndex = -1;
      }
    }
  }, {
    key: "select",
    value: function select(event) {
      console.log('Select called');
      var item = event.currentTarget;
      var id = item.dataset.id;
      var value = item.dataset.value || id;
      var label = item.dataset.label;
      var firstName = item.dataset.firstName;
      var lastName = item.dataset.lastName;
      console.log('Selected item:', {
        id: id,
        value: value,
        label: label,
        firstName: firstName,
        lastName: lastName
      });
      this.inputTarget.value = label;
      if (this.hasHiddenTarget) {
        this.hiddenTarget.value = value;
        console.log('Set hidden field to:', value);
      }

      // Populate first name and last name fields if they exist and have values
      if (this.hasFirstNameFieldValue && firstName) {
        var firstNameField = document.querySelector(this.firstNameFieldValue);
        if (firstNameField) {
          firstNameField.value = firstName;
          console.log('Set first name to:', firstName);
        }
      }
      if (this.hasLastNameFieldValue && lastName) {
        var lastNameField = document.querySelector(this.lastNameFieldValue);
        if (lastNameField) {
          lastNameField.value = lastName;
          console.log('Set last name to:', lastName);
        }
      }
      this.hideResults();
    }
  }, {
    key: "highlight",
    value: function highlight(event) {
      var items = this.resultsTarget.querySelectorAll('.ui-menu-item');
      items.forEach(function (item) {
        return item.classList.remove('active');
      });
      event.currentTarget.classList.add('active');
    }
  }, {
    key: "navigate",
    value: function navigate(event) {
      var items = this.resultsTarget.querySelectorAll('.ui-menu-item');
      if (items.length === 0) return;
      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();
          this.selectedIndex = Math.min(this.selectedIndex + 1, items.length - 1);
          this.updateSelection(items);
          break;
        case 'ArrowUp':
          event.preventDefault();
          this.selectedIndex = Math.max(this.selectedIndex - 1, -1);
          this.updateSelection(items);
          break;
        case 'Enter':
          event.preventDefault();
          if (this.selectedIndex >= 0) {
            items[this.selectedIndex].click();
          }
          break;
        case 'Escape':
          this.hideResults();
          break;
        default:
          break;
      }
    }
  }, {
    key: "updateSelection",
    value: function updateSelection(items) {
      var _this4 = this;
      items.forEach(function (item, index) {
        if (index === _this4.selectedIndex) {
          item.classList.add('active');
          item.scrollIntoView({
            block: 'nearest'
          });
        } else {
          item.classList.remove('active');
        }
      });
    }
  }, {
    key: "escapeHtml",
    value: function escapeHtml(text) {
      if (!text) return '';
      var div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }, {
    key: "escapeAttr",
    value: function escapeAttr(text) {
      if (!text) return '';
      return String(text).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
  }]);
}(Controller);
_defineProperty(_default, "targets", ['input', 'results', 'hidden']);
_defineProperty(_default, "values", {
  url: String,
  minChars: {
    type: Number,
    "default": 2
  },
  firstNameField: String,
  lastNameField: String
});
export { _default as default };